import React from "react";
import { pure } from "recompose";

import CEOGoals from "./CEOGoals";
import PDGoals from "./PDGoals";
import PMGoals from "./PMGoals";
import OPGoals from "./OPGoals";
import FIGoals from "./FIGoals";

const renderGoals = (
  role,
  { team, products, unaccepted_decisions, forecasts, promos, sales }
) => {
  switch (role) {
    case "CEO":
      return <CEOGoals team={team} />;
    case "PD":
      return <PDGoals unaccepted_decisions={unaccepted_decisions} />;
    case "PM":
      return <PMGoals forecasts={forecasts} promos={promos} sales={sales} />;
    case "OP":
      return <OPGoals products={products} />;
    default:
      return <FIGoals team={team} />;
  }
};

const TeamDecision = pure(({ name, role, ...props }) => (
  <div className="team-decision" key={name}>
    <p className="team-decision__name">{name}</p>
    {renderGoals(role, props)}
  </div>
));

export default TeamDecision;



// WEBPACK FOOTER //
// ./src/components/dashboard/TeamDecision.js